module.exports = __webpack_public_path__ + "static/media/Source Info.bc88bda0.txt";